import React, { useEffect, useState } from "react";
import testimoniosData from '../data/testimonios.json'

function TestimonialCard({ testimonio }) {
  // const [testimonios, setTestimonios] = useState([]);
  // useEffect(()=>{
  //   setTestimonios(testimoniosData);
  //   // console.log(testimonios);
  // },[])
  return (
    <div className="p-10 w-full h-full bg-yellow-50 shadow-[-10px_10px_0px_0px_#0d2334] flex flex-col justify-center gap-3 rounded-lg rounded-tl-none snap-center">
      <div className="flex flex-col text-left gap-2 ">
        <p className="hyphens-none text-xl">
          <i class="fa-solid fa-quote-left "></i> {testimonio.testimonio}{" "}
          <i class="fa-solid fa-quote-right"></i>
        </p>
      </div>
      <div className="flex flex-row justify-start items-center ">
        <div className="w-24 h-24 scale-[80%] border-blue-4 border-4 rounded-full bg-yellow-4 overflow-hidden">
          <img
            src={testimonio.imagen}
            alt="lo que dicen nuestros estudiantes de Brighton Centro de Inglés"
            className="object-cover object-center w-full h-full"
          />
        </div>
        <div className="flex flex-col items-start">
          <p className="text-2xl">{testimonio.nombre}</p>
          <p className="font-Bebas font-bold text-xl text-blue-6 tracking-wider">{testimonio.rol}</p>
        </div>
      </div>
    </div>
  );
}

export default TestimonialCard;
